import { backend } from '@/services/backend'
import { NotificationSettings, ReadingStreakData16464 } from './interfaces'

import { Sentry } from '@/services/sentry'
import { streaks16464Variant } from '@/services/ab'

export class SettingsView {
  private _isLoading: boolean
  private _isError: boolean

  private _notificationSettings?: NotificationSettings
  private _readingStreakData16464?: ReadingStreakData16464

  constructor() {
    this._isLoading = false
    this._isError = false
  }

  public async init(): Promise<void> {
    try {
      this._isLoading = true
      this._notificationSettings = await backend.getNotificationSettings()
      if (streaks16464Variant() === 'B') {
        this._readingStreakData16464 = await backend.getReadingStreak16464()
      }
    } catch (error: any) {
      this._isError = true
      Sentry.captureException(error)
    } finally {
      this._isLoading = false
    }
  }

  public get isLoaded(): boolean {
    return (
      !this._isLoading &&
      !this._isError &&
      this._notificationSettings !== undefined
    )
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  public get isError(): boolean {
    return this._isError
  }

  public get notificationSettings():
    | Readonly<NotificationSettings>
    | undefined {
    return this._notificationSettings
  }

  get readingStreakData16464(): ReadingStreakData16464 | undefined {
    return this._readingStreakData16464
  }

  public async toggleNotificationSetting(
    setting: keyof NotificationSettings,
    value: boolean,
  ): Promise<void> {
    if (this._notificationSettings === undefined) {
      return
    }

    this._notificationSettings[setting] = value
    this._notificationSettings = await backend.putNotificationSettings(
      this._notificationSettings,
    )
  }
}
